import { render, staticRenderFns } from "./TambahMenuPegawaiMobile.vue?vue&type=template&id=66a31016&scoped=true"
import script from "./TambahMenuPegawaiMobile.vue?vue&type=script&lang=js"
export * from "./TambahMenuPegawaiMobile.vue?vue&type=script&lang=js"
import style0 from "./TambahMenuPegawaiMobile.vue?vue&type=style&index=0&id=66a31016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a31016",
  null
  
)

export default component.exports